// Item 30: dashboard / report parameters — one definition list (canvas.what_if)
// that drives calculated measures ([name]), bound filters (field + op) and
// {param:name} tokens in titles and text. What-if sliders are the numeric case.
export const PARAM_TYPES = [
  { value: "number", label: "Number (slider)" },
  { value: "list", label: "List of values" },
  { value: "text", label: "Free text" },
  { value: "date", label: "Date" },
  { value: "boolean", label: "Yes / no" },
];

export const PARAM_OPS = [
  { value: "eq", label: "equals" },
  { value: "in", label: "is one of" },
  { value: "neq", label: "not equals" },
  { value: "gte", label: "≥" },
  { value: "lte", label: "≤" },
  { value: "gt", label: ">" },
  { value: "lt", label: "<" },
  { value: "contains", label: "contains" },
];

export const paramType = (d) => (d && d.type) || "number";

export function paramDefault(d) {
  const t = paramType(d);
  if (d && d.default !== undefined && d.default !== null && d.default !== "") return d.default;
  if (t === "number") return Number(d?.default ?? 0) || 0;
  if (t === "boolean") return false;
  if (t === "list") return d?.multi ? [] : "";
  return "";
}

export function paramValue(d, values) {
  const v = values ? values[d.name] : undefined;
  return v === undefined ? paramDefault(d) : v;
}

const isEmpty = (v) => v === null || v === undefined || v === "" || (Array.isArray(v) && !v.length);

// Parameters bound to a dataset field behave like dashboard-level filters.
export function paramFilters(defs = [], values = {}) {
  const out = [];
  (defs || []).forEach((d) => {
    if (!d || !d.name || !d.field) return;
    const v = paramValue(d, values);
    if (isEmpty(v) || v === false) return;
    const op = d.op || (Array.isArray(v) ? "in" : "eq");
    out.push({
      ...(d.dataset_id ? { dataset_id: d.dataset_id } : {}),
      field: d.field,
      op,
      value: op === "in" && !Array.isArray(v) ? [v] : v,
      __param: d.name,
    });
  });
  return out;
}

// {param:name} / {{param:name}} tokens in widget titles, text and headers.
export function resolveParamTokens(text, params) {
  if (!text || typeof text !== "string" || !params) return text;
  return text.replace(/\{\{?\s*param\s*:\s*([\w.-]+)\s*\}?\}/gi, (m, name) => {
    const v = params[name];
    if (v === undefined || v === null) return m;
    return Array.isArray(v) ? v.join(", ") : String(v);
  });
}
